import { SourceSettings } from '../source-settings';

export type StaticSearchItemType = 'open-external';

export interface StaticItemsSourceSettings extends SourceSettings {
  type: 'static-items';
  itemTypes: StaticSearchItemType[];
  isExternalEmbed?: boolean;
}
